import {
  faArrowLeft,
  faEye,
  faPencil,
  faTachometer,
  faTasks,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

import ActiveUsers from "./components/active-users";
import PromoCodeActive from "./components/promo-code-details";

function PromoCodeDetail() {
  const { id } = useParams();
  const [activeTab, setActive] = useState("details");

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/promo-code" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faTicket} />
                  &nbsp;Promo Code
                </Link>
              </li>
              <li class="is-active">
                <Link aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Details
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/promo-code`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Promo Code
                </Link>
              </li>
            </ul>
          </nav>

          {/* Page */}
          <nav class="box">
            {/* Title + Options */}
            <div class="columns">
              <div class="column">
                <p class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faTasks} />
                  &nbsp;Promo Code
                </p>
              </div>
              <div class="column has-text-right">
                <Link
                  class="button is-small is-warning is-fullwidth-mobile"
                  type="button"
                >
                  <FontAwesomeIcon className="mdi" icon={faPencil} />
                  &nbsp;Edit Promo Code
                </Link>
              </div>
            </div>

            {/* Tab Navigation */}

            <div class="tabs is-medium">
              <ul>
                <li>
                  <Link
                    onClick={() => setActive("details")}
                    class={activeTab === "details" ? "is-active-tab" : ""}
                  >
                    Detail
                  </Link>
                </li>
                <li>
                  <Link
                    class={activeTab === "active" ? "is-active-tab" : ""}
                    onClick={() => setActive("active")}
                  >
                    Active Users
                  </Link>
                </li>
              </ul>
            </div>

            {activeTab === "details" && <PromoCodeActive id={id} />}
            {activeTab === "active" && <ActiveUsers id={id} />}
          </nav>
        </section>
      </div>
    </>
  );
}

export default PromoCodeDetail;
